<template>
    <div>
        <h1 style="text-align: center;">Video Editor</h1>
        <div v-if="isLoading" class="loading">PLEASE WAIT...</div>
        <div>
            <div ref="cntTitle">
                <h2>Title</h2>
                <div><input type="text" v-model="title" style="width: 100%"></div>
            </div>
            <div ref="cntThumb">
                <h2>Image</h2>
                <div v-if="thumbnail.data"><img :src="thumbnail.data" height="200px" width="100%" style="object-fit: contain;"></div>
                <div><input type="file" ref="thumbsel" v-on:change="changeImage(thumbnail, 'thumbsel')" accept="image/jpeg" style="width: 100%; color: black;"></div>
            </div>
            <div ref="cntVideo">
                <h2>Video File</h2>
                <video :src="video.preview" style="width:100%; height: 400px;" controls v-if="video.preview"></video>
                <input type="button" value="Browse MP4 Video Files..." @click="$refs['videofile'].click()">
                <input type="file" :ref="'videofile'" accept="video/mp4" v-on:change="changeFile($event.target.files[0])" style="display:none;">
                <input type="text" :value="video.upload.file ? video.upload.file.name : 'No File Chosen'" style="width: 50%" disabled>
            </div>
            <div>
                <button @click="submitThis()" class="submit-btn">Submit</button>
            </div>
        </div>
    </div>
</template>

<script>
import {Functions} from './functions.js';

export default {
    name: "VideoEditComponent",
    props: ['ID'],
    data: () => ({
        isLoading: true,
        title: "",
        id: undefined,
        ed: {
          Location: undefined,
          Thumbnail: undefined
        },
        thumbnail: {
            file: undefined,
            data: "",
            publicUrl: "",
            uploadUrl: ""
        },
        video: {
                    upload: {
                        file: undefined,
                        uploadUrl: undefined,
                        key: undefined
                    },
                    data: {
                        s: undefined
                    },
                    preview: undefined
        },
        functions: undefined
    }),
    mounted: function(){
            this.functions = new Functions();
            if(this.ID){
              console.log("EDITING");
              this.id = this.ID;
            this.functions.getComponentVidAud(this.id, (data) => {
              let dat = data.dat[0];
              this.title = dat.Title;
              this.ed.Location = dat.Location;
              this.ed.Thumbnail = dat.Thumbnail;
              this.functions.getSignedUrl("ttedu-static", dat.Thumbnail, "image/jpeg", "getObject", (thumbBuff) => {
                this.thumbnail.data = thumbBuff.signedUrl;
                this.functions.getSignedUrl("ttedu-static", dat.Thumbnail, "image/jpeg", "putObject", (thumbBuff1) => {
                  this.thumbnail.uploadUrl = thumbBuff1.signedUrl;
                  this.functions.getSignedUrl("ttedu-static", dat.Location, "video/mp4", "getObject", (vidBuff) => {
                    this.video.preview = vidBuff.signedUrl;
                    this.functions.getSignedUrl("ttedu-static", dat.Location, "video/mp4", "putObject", (vidBuff1) => {
                      this.video.upload.uploadUrl = vidBuff1.signedUrl;
                      this.isLoading = false;
                    });
                  });
                });
              });
            });
            }else{
              this.functions.getThumbURL((dat) => {
                  this.thumbnail.publicUrl = dat.key;
                  this.thumbnail.uploadUrl = dat.signedUrl;
                      //getSignedUrl(bucket, key, contentType, operation, callback){
                      let key = "videos/" + (new Date().getTime()) + "XX" + Math.floor(Math.random() * 10000000) + "XXvideo.mp4";
                      this.video.upload.key = key;
                      this.functions.getSignedUrl("ttedu-static", key, "video/mp4", "putObject", (data) => {
                          this.video.upload.uploadUrl = data.signedUrl;
                          this.video.data.s = "https://ttedu-public-uploads.s3.amazonaws.com/" + key;
                          this.isLoading = false;
                          console.log(this.video);
                      });
              },(err) => {
                  console.error(err);
              });
            }
    },
    methods: {
        changeFile(file){
            this.video.preview = URL.createObjectURL(file);
            this.video.upload.file = file;
            console.log(this.video.preview);
        },
        changeImage: function(img, selref){
            var reader = new FileReader();
            reader.onload = (e) => {
                img.data = e.target.result;
            }
            if(this.$refs[selref].length){
                reader.readAsDataURL(this.$refs[selref][0].files[0]);
                img.file = this.$refs[selref][0].files[0];
            }else{
                reader.readAsDataURL(this.$refs[selref].files[0]);
                img.file = this.$refs[selref].files[0];
            }
        },
        submitThis(){
            let hasError = false;
            this.isLoading = true;

            if(this.title.trim() == ""){ hasError = true; this.$refs.cntTitle.classList.add("has-error") }
            else this.$refs.cntTitle.classList.remove("has-error")
            if(this.id == undefined){
              if(this.thumbnail.file == undefined) {this.$refs.cntThumb.classList.add("has-error"); hasError = true;}
              else this.$refs.cntThumb.classList.remove("has-error")
              if(this.video.upload.file == undefined) {this.$refs.cntVideo.classList.add("has-error"); hasError = true;}
              else this.$refs.cntVideo.classList.remove("has-error")

              var componentData = {
                  ContentType: "VIDEO",
                  Title: this.title,
                  Thumbnail: this.thumbnail.publicUrl,
                  Component: "video",
                  Location: this.video.upload.key
              };
              // console.log(componentData);
              // return null;

              this.functions.uploadVideo(this.video.upload.uploadUrl, this.video.upload.file, (dat) => {
                this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                    this.functions.updateComponentAudVid(this.id, componentData,(dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/video");
                    });
                });
              });
            }else{
              console.log("UPDATING");
              var componentData = {
                  ContentType: "VIDEO",
                  Title: this.title,
                  Thumbnail: this.ed.Thumbnail,
                  Component: "video",
                  Location: this.ed.Location
              };


              if(this.video.upload.file){
                //update video
                this.functions.uploadVideo(this.video.upload.uploadUrl, this.video.upload.file, (dat) => {
                  if(this.thumbnail.file){
                    this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                      this.functions.updateComponentAudVid(this.id, componentData,(dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/video");
                      });
                    });
                  }else {
                    this.functions.updateComponentAudVid(this.id, componentData,(dat) => {
                      console.log(dat);
                      this.$router.push("/editors/component/video");
                    });
                  }
                });
              }else if(this.thumbnail.file){
                this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                  this.functions.updateComponentAudVid(this.id, componentData,(dat) => {
                    console.log(dat);
                    this.$router.push("/editors/component/video");
                  });
                });
              }else {
                this.functions.updateComponentAudVid(this.id, componentData,(dat) => {
                  console.log(dat);
                  this.$router.push("/editors/component/video");
                });
              }
            }
        },
    }
}
</script>


<style scoped>
    .quill-editor{
        background: white;
        color: black;
    }
    .ql-container.ql-snow{
        background: white !important;
    }
    h2{
      color:black;
    }
    .submit-btn{
        width: 100%;
        height: 2em;
        font-size: 1.5em;
        font-weight: 800;
        margin-top: 0.5em;
    }
    .has-error{
        border: red 5px solid;
        box-sizing: border-box;
    }
    .has-error::after{
        content: "Missing Field Data";
        color: red;
        background: white;
        font-weight: 800;
    }
    .loading{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        justify-content: center;
        text-align: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        display: flex;
        font-size: 4em;
        font-weight: 900;
    }
</style>